// Mock data for RAILS by DX Landing Page

export const heroData = {
  title: "RAILS by DX",
  subtitle: "Robotics & AI for Non-Tech Leaders",
  description: "Transform your career with AI expertise. Join thousands of professionals mastering Robotics and AI systems, apps, and tools that revolutionize their daily work.",
  primaryCTA: "Join Our Community",
  secondaryCTA: "Sign Up for Next Session",
  heroImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800"
};

export const aboutData = {
  title: "About RAILS by DX",
  description: "RAILS by DX (Robotics and AI for Non-Tech Leaders) is powered by DobbleHelix. We're building a community where professionals from any discipline can become AI-native experts—regardless of their technical background.",
  mission: "Our mission is to make millions of people AI-native experts at their current and future jobs, regardless of discipline, sector, or prior technical knowledge.",
  stats: [
    { value: "1000+", label: "Active Members" },
    { value: "25+", label: "Projects Done" },
    { value: "50+", label: "Training Sessions" },
    { value: "100+", label: "AI Tools Covered" },
    { value: "20+", label: "Industry Sectors" }
  ]
};

export const coreFunctions = [
  {
    id: 1,
    icon: "GraduationCap",
    title: "Learn",
    description: "Focused training sessions in General and Discipline-specific models, leading to certification. Master AI and Robotics through curated videos and hands-on learning.",
    features: [
      "General AI training sessions",
      "Discipline-specific courses",
      "Certification programs",
      "Video learning library"
    ],
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600",
    comingSoon: false
  },
  {
    id: 2,
    icon: "Wrench",
    title: "Tools",
    description: "Access aggregated AI and Robotics tools, master their usage, and gain easier, cheaper access to cutting-edge technology.",
    features: [
      "Curated tool directory",
      "Hands-on tutorials",
      "Exclusive discounts",
      "Tool comparisons"
    ],
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600",
    comingSoon: false
  },
  {
    id: 3,
    icon: "Rocket",
    title: "Projects",
    description: "Get hands-on experience with live AI and Robotics projects. Test, learn, and contribute to real-world implementations.",
    features: [
      "Real project experience",
      "Testing opportunities",
      "Collaborative building",
      "Portfolio development"
    ],
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=600",
    comingSoon: false
  },
  {
    id: 4,
    icon: "MessageSquare",
    title: "Forum",
    description: "Engage with an active online forum and newsroom. Connect with fellow members, share insights, and stay updated on the latest AI developments.",
    features: [
      "Community discussions",
      "AI news and updates",
      "Member networking",
      "Expert Q&A"
    ],
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600",
    comingSoon: true
  },
  {
    id: 5,
    icon: "Briefcase",
    title: "Jobs",
    description: "Discover AI job opportunities—from full-time positions to part-time gigs. Connect your new skills with real-world opportunities.",
    features: [
      "Full-time positions",
      "Part-time gigs",
      "Freelance projects",
      "Career guidance"
    ],
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600",
    comingSoon: true
  }
];

export const membershipData = {
  title: "Membership Plans",
  subtitle: "Coming Soon",
  description: "We're crafting membership tiers designed to give you the best learning experience. Stay tuned for exclusive benefits, early access, and premium features.",
  plans: [
    {
      id: 1,
      name: "Free",
      status: "Coming Soon",
      features: [
        "Access to community forum",
        "Basic learning resources",
        "Monthly newsletters",
        "Event notifications"
      ]
    },
    {
      id: 2,
      name: "Professional",
      status: "Coming Soon",
      featured: true,
      features: [
        "All Free features",
        "Unlimited course access",
        "Certification programs",
        "Tool discounts",
        "Priority job listings"
      ]
    },
    {
      id: 3,
      name: "Enterprise",
      status: "Coming Soon",
      features: [
        "All Professional features",
        "Custom training sessions",
        "Dedicated support",
        "Team management",
        "Advanced analytics"
      ]
    }
  ]
};

export const ctaData = {
  primary: {
    title: "Ready to Become an AI-Native Expert?",
    description: "Join thousands of professionals transforming their careers with AI and Robotics knowledge.",
    buttonText: "Join Our Community",
    buttonAction: "joinCommunity"
  },
  secondary: {
    title: "Don't Miss Our Next Learning Session",
    description: "Be the first to know about upcoming training sessions, workshops, and exclusive events.",
    buttonText: "Sign Up for Updates",
    buttonAction: "signUpSession",
    placeholder: "Enter your email address"
  }
};

export const footerData = {
  about: "RAILS by DX is a DobbleHelix initiative dedicated to making AI and Robotics accessible to non-tech leaders across all disciplines and sectors.",
  links: [
    { label: "About Us", href: "#about" },
    { label: "Learn", href: "#learn" },
    { label: "Tools", href: "#tools" },
    { label: "Projects", href: "#projects" },
    { label: "Forum", href: "#forum" },
    { label: "Jobs", href: "#jobs" }
  ],
  social: [
    { platform: "Twitter", icon: "Twitter", href: "#" },
    { platform: "LinkedIn", icon: "Linkedin", href: "#" },
    { platform: "GitHub", icon: "Github", href: "#" }
  ],
  contact: {
    emails: [
      { display: "rails[at]dobblehelix[dot]com", mailto: "rails@dobblehelix.com" },
      { display: "hello[at]railsbydx[dot]com", mailto: "hello@railsbydx.com" }
    ],
    whatsapp: [
      "+1 347 952 2041",
      "+234 818 299 6800",
      "+234 905 948 0259"
    ],
    locations: [
      "Atlanta, USA",
      "Lagos, Nigeria",
      "London, UK"
    ]
  },
  copyright: "© 2024 RAILS by DX - DobbleHelix. All rights reserved."
};

// Form submission handlers (mock)
export const handleJoinCommunity = (formData) => {
  console.log("Join Community Form:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Welcome to RAILS by DX! Check your email for next steps." });
    }, 1000);
  });
};

export const handleSignUpSession = (email) => {
  console.log("Sign up for session:", email);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "You're on the list! We'll notify you about upcoming sessions." });
    }, 1000);
  });
};
